import createDocumentResource from 'src/actions/shared/createDocumentResource';
import ChatCampaignSettings from 'src/models/ChatCampaigns/ChatCampaignSettings';

const chatCampaignSettingsResource = createDocumentResource<ChatCampaignSettings>({
  name: 'chatCampaignSettings',
  endpoint: 'v1/orgs/:orgId/chat-campaign-settings',
  type: ChatCampaignSettings,
});

export default chatCampaignSettingsResource;
